import React, { FC, useCallback } from 'react';
import styled from 'styled-components';

import { AgentStatusType, AgentStatusUpdateTrigger as AgentStatusUpdateTriggerType } from 'src/actions/rules/trigger';
import { StyledDropdown } from '../shared/StyledComponents';

type AgentStatusUpdateTriggerProps = {
  trigger: AgentStatusUpdateTriggerType;
  onChange: Function;
};

const AgentStatusUpdateTrigger: FC<AgentStatusUpdateTriggerProps> = ({ trigger, onChange }) => {
  const onChangeStatus = useCallback(
    value => {
      trigger.setValue(value);
      onChange(trigger);
    },
    [trigger, onChange]
  );

  return (
    <DropdownWrapper>
      <StyledDropdown onSelect={onChangeStatus} options={statusOptions} value={trigger.value} leftMargin={false} />
    </DropdownWrapper>
  );
};

const DropdownWrapper = styled.div`
  flex: 1 0 auto;
`;

const statusOptions: { label: string; value: string }[] = [
  { label: 'Away', value: AgentStatusType.Away },
  { label: 'Offline', value: AgentStatusType.Offline },
];

export default AgentStatusUpdateTrigger;
